// Onboard-Completion-Guard: reine Logik, getrennt vom Component, damit sie ohne
// Browser/React unit-testbar ist (node importiert .mjs nativ). KEINE React-Imports.
//
// Problem (T0-ARCH): nach Entfernen der calib-Stage ist der Onboard-Lauf zu schnell
// fürs 3s-Polling — der frühere Guard (sawRunningRef) verlangte einen beobachteten
// running:true-Poll, der bei schnellen Läufen verpasst wird → onboarding blieb true.
//
// Fix: der Guard hängt NICHT mehr an einem beobachteten running:true-Poll, sondern
// an `runConfirmed` — gesetzt, sobald DIESER Lauf per /onboard/start bestätigt
// gestartet ist. Damit gilt:
//   - schneller Lauf  → runConfirmed=true direkt nach start() → done wird honoriert,
//     auch wenn kein running:true-Poll je gesehen wurde;
//   - stale done:true aus dem VORLAUF (vor dem Start dieses Laufs, runConfirmed=false)
//     → weiterhin geblockt (bewahrt den 03d4e41-Zweck). runConfirmed wird zu Beginn
//     von runOnboard auf false zurückgesetzt und erst NACH bestätigtem start() true;
//     das Backend setzt bei start() _running=True + manifest=None synchron, sodass
//     jedes spätere done:true von DIESEM Lauf stammt.

/**
 * Entscheidet, ob der done/error-Status DIESES Laufs honoriert werden darf.
 * @param {object} s
 * @param {boolean} s.launched      ein Lauf wurde in dieser Session gestartet
 * @param {boolean} s.statusOk      der letzte /onboard/status-Poll war gültig (ok())
 * @param {boolean} s.runConfirmed  DIESER Lauf ist per start() bestätigt (nicht Vorlauf)
 * @param {boolean} s.done          onb.done
 * @param {boolean} s.error         onb.error truthy?
 * @returns {"done"|"error"|null}   was zu honorieren ist (null = nichts/blocken)
 */
export function classifyCompletion({ launched, statusOk, runConfirmed, done, error }) {
  if (!launched || !statusOk || !runConfirmed) return null;  // Stale-/Vorlauf-Schutz
  if (done) return "done";
  if (error) return "error";
  return null;
}
